export default "__VITE_ASSET__DWtJiRC7__"